import React from 'react';
import { Chip } from '@mui/material';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const  DescriptionFormatter = ({ row }) => {
  return (
    <>
      {row.description && row.description.includes('\n') ? (
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {row.description.split(/\r?\n/).filter(Boolean).map((info, i) => (
            <li key={i} style={{ color: '#222', fontSize: 15 }}>{info.trim()}</li>
          ))}
        </ul>
      ) : (
        row.description
      )}
    </>
  );
};
const DescriptionTypeProvider = props => <DataTypeProvider formatterComponent={DescriptionFormatter} {...props} />

export default DescriptionTypeProvider;
